// src/components/hooks/useTripPlanner.ts
import { useState, useCallback } from "react";
import { fetchTripResults } from "@/services/tripService";
import { TripResult } from "@/types/trip.types";
import { Stops } from "@/types/trip.types";
import { showPopup } from "@/components/warnings/Popup";

export function useTripPlanner() {
  const [tripResult, setTripResult] = useState<TripResult | null>(null);
  const [tripLoading, setTripLoading] = useState(false);
  const [tripVersion, setTripVersion] = useState(0);
  const [emissionsLoaded, setEmissionsLoaded] = useState<Record<string, boolean>>({});
  const [snapRadius, setSnapRadiusValue] = useState<number>(1000);

  function setSnapRadius(
    radius: number
  ) {
    if (radius>25e3) {
      showPopup("Error", "Snap radius must be less than 25km.");
      return;
    }
    setSnapRadiusValue(radius);
  }


  const planTrip = useCallback(
    async (stops: Stops) => {
      setTripLoading(true);
      try {
        const data = await fetchTripResults(
          stops.map((s) => s.coords),
          snapRadius
        );
        setTripResult(data);
        setTripVersion((v) => v + 1);
      } catch {
        showPopup(
          "Route Error",
          "Unable to provide route for current locations."
        )
        setTripResult(null)
      } finally {
        setTripLoading(false);
      }
    },
    [snapRadius]
  );

  const clearTripResults = () => setTripResult(null);

  return { 
    tripResult, 
    tripLoading, 
    tripVersion, 
    planTrip, 
    clearTripResults, 
    setTripLoading,
    emissionsLoaded,
    setEmissionsLoaded,
    snapRadius,
    setSnapRadius
  };
}
